import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { TerminalService } from '@services/terminal.service';

@Component({
  selector: 'app-terminal-check-in-mode',
  imports: [TranslateModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './terminal-check-in-mode.component.html',
})
export class TerminalCheckInModeComponent {
  private readonly terminalService = inject(TerminalService);
  private readonly toastr = inject(ToastrService);
  private readonly translate = inject(TranslateService);

  private readonly terminal = this.terminalService.currentTerminal;

  protected readonly checkInEnabled = computed(() => this.terminal()?.is_check_in ?? false);

  toggleCheckInMode(): void {
    const terminal = this.terminal();
    if (!terminal) {
      return;
    }

    this.terminalService
      .updateTerminal({ ...terminal, is_check_in: !terminal.is_check_in })
      .subscribe({
        error: () => {
          this.toastr.error(
            this.translate.instant('admin_settings.check_in.errors.update_error_message'),
            this.translate.instant('admin_settings.check_in.errors.update_error_title'),
          );
        },
      });
  }
}
